class StorefrontApi {
	static accessToken = "a64a9e2b42f51dbf79ab4fcc0bec3c82";
	apiVersion;

	constructor(apiVersion = "2023-01") {
		this.apiVersion = apiVersion;
	}

	get url() {
		return `/api/${this.apiVersion}/graphql.json`;
	}

	async query(query, variables = {}, operationName = "") {
		const response = await fetch(this.url, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-Shopify-Storefront-Access-Token": this.constructor.accessToken,
			},
			body: JSON.stringify({
				query,
				variables,
				operationName,
			}),
		});

		if (!response.ok) {
			throw new Error(
				`Network error from GraphQL response: ${response.status} - ${response.statusText}`
			);
		}

		const { data, errors } = await response.json();

		if (errors) {
			const message = errors.map((error) => error.message).join("\n");
			throw new Error(`GraphQL errors:\n${message}`);
		}

		return data;
	}
}

export default StorefrontApi;
